<template>
  <!-- prettier-ignore -->
  <ovp-button
    class="action-button"
    primary
    @click="$emit('click')">
    {{ hasPersons ? $t('basket.gotoBasket') : $t('basket.gotoConfigurator') }}
  </ovp-button>
</template>

<script>
export default {
  name: 'Action',

  props: {
    hasPersons: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style name="mobile" scoped>
.action-button {
  width: 100%;
  margin-bottom: 0;
}
</style>
